import { getApiClient } from './ApiClient'

export const mealCategoryListPromise = (params) => {
  return getApiClient()
    .get('/meal-categories', {
      params
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealCategoryDetailPromise = (id) => {
  return getApiClient()
    .get(`/meal-categories/${id}`)
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealCategoryUpsertPromise = (body) => {
  return getApiClient()
    .post('/meal-categories/upsert', {
      body
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}
